// ─────────────────────────────────────────────────────────────────────
// «DEV · ALL RIGHTS» — the unrestricted development identity, made visible.
//
// QUIET ON PURPOSE, and that is the difference from `ImpersonationBanner`.
// That one is loud because the expensive mistake is acting on a real
// customer's data while forgetting you are inside their organization. This
// one guards against a different and much cheaper error: reading the
// product's RBAC off a session that is deliberately ignoring it, and
// concluding a role grants something it does not.
//
// So: a small persistent chip, no colour that reads as an alarm, no dialog.
// Enough that nobody debugs a permissions question from the one session
// where permissions are not being asked.
//
// IT RENDERS FROM THE ACTIVE PERSONA KEY, which lives in app state, so it
// disappears on a reload until a persona is picked again — exactly like the
// persona bar's own highlight, and for the same reason. Persisting it would
// mean inventing a store whose only job is to remember a development flag,
// and a stale claim there would be worse than a missing one.
// ─────────────────────────────────────────────────────────────────────

/** The persona key whose session carries the server-side all-rights override. */
export const DEV_ALL_RIGHTS_PERSONA = 'full';

export function DevAllRightsMarker({ persona }: { persona: string | null }) {
  if (persona !== DEV_ALL_RIGHTS_PERSONA) return null;

  return (
    <div
      data-testid="dev-all-rights-marker"
      role="status"
      className="sticky top-0 z-40 flex items-center gap-2 px-4 py-1 font-mono text-[11px] uppercase tracking-wider"
      style={{ background: '#1f2937', color: '#d1d5db' }}
    >
      <span aria-hidden="true">●</span>
      <span>DEV · All rights</span>
      {/* ENGLISH, and that is not an oversight. This is a developer-facing
          diagnostic on a dev-only surface, so it needs no catalog key — and
          adding Norwegian prose here would have meant putting a brand-new
          file on the frozen legacy-surface list, which is meant to shrink.
          The i18n ratchet caught exactly that on the first draft. */}
      <span className="opacity-70 normal-case tracking-normal">
        — development identity, not real permissions
      </span>
    </div>
  );
}
